/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CurrentMonthCountEnrollmentScheduleDto } from '../models/current-month-count-enrollment-schedule-dto';
import { CursorSearchEnrollmentScheduleResponseDto } from '../models/cursor-search-enrollment-schedule-response-dto';
import { enrollmentScheduleControllerCancelScheduleV1 } from '../fn/enrollment-schedule/enrollment-schedule-controller-cancel-schedule-v-1';
import { EnrollmentScheduleControllerCancelScheduleV1$Params } from '../fn/enrollment-schedule/enrollment-schedule-controller-cancel-schedule-v-1';
import { enrollmentScheduleControllerCopyV1 } from '../fn/enrollment-schedule/enrollment-schedule-controller-copy-v-1';
import { EnrollmentScheduleControllerCopyV1$Params } from '../fn/enrollment-schedule/enrollment-schedule-controller-copy-v-1';
import { enrollmentScheduleControllerCreateSupplementV1 } from '../fn/enrollment-schedule/enrollment-schedule-controller-create-supplement-v-1';
import { EnrollmentScheduleControllerCreateSupplementV1$Params } from '../fn/enrollment-schedule/enrollment-schedule-controller-create-supplement-v-1';
import { enrollmentScheduleControllerCreateV1 } from '../fn/enrollment-schedule/enrollment-schedule-controller-create-v-1';
import { EnrollmentScheduleControllerCreateV1$Params } from '../fn/enrollment-schedule/enrollment-schedule-controller-create-v-1';
import { enrollmentScheduleControllerDeleteRepeatV1 } from '../fn/enrollment-schedule/enrollment-schedule-controller-delete-repeat-v-1';
import { EnrollmentScheduleControllerDeleteRepeatV1$Params } from '../fn/enrollment-schedule/enrollment-schedule-controller-delete-repeat-v-1';
import { enrollmentScheduleControllerDeleteV1 } from '../fn/enrollment-schedule/enrollment-schedule-controller-delete-v-1';
import { EnrollmentScheduleControllerDeleteV1$Params } from '../fn/enrollment-schedule/enrollment-schedule-controller-delete-v-1';
import { enrollmentScheduleControllerFindAllByTicketIdV1 } from '../fn/enrollment-schedule/enrollment-schedule-controller-find-all-by-ticket-id-v-1';
import { EnrollmentScheduleControllerFindAllByTicketIdV1$Params } from '../fn/enrollment-schedule/enrollment-schedule-controller-find-all-by-ticket-id-v-1';
import { enrollmentScheduleControllerFindByCurrentMonthTicketV1 } from '../fn/enrollment-schedule/enrollment-schedule-controller-find-by-current-month-ticket-v-1';
import { EnrollmentScheduleControllerFindByCurrentMonthTicketV1$Params } from '../fn/enrollment-schedule/enrollment-schedule-controller-find-by-current-month-ticket-v-1';
import { enrollmentScheduleControllerFindByIdV1 } from '../fn/enrollment-schedule/enrollment-schedule-controller-find-by-id-v-1';
import { EnrollmentScheduleControllerFindByIdV1$Params } from '../fn/enrollment-schedule/enrollment-schedule-controller-find-by-id-v-1';
import { enrollmentScheduleControllerFindByTicketIdV1 } from '../fn/enrollment-schedule/enrollment-schedule-controller-find-by-ticket-id-v-1';
import { EnrollmentScheduleControllerFindByTicketIdV1$Params } from '../fn/enrollment-schedule/enrollment-schedule-controller-find-by-ticket-id-v-1';
import { enrollmentScheduleControllerFindCountV1 } from '../fn/enrollment-schedule/enrollment-schedule-controller-find-count-v-1';
import { EnrollmentScheduleControllerFindCountV1$Params } from '../fn/enrollment-schedule/enrollment-schedule-controller-find-count-v-1';
import { enrollmentScheduleControllerFindCurrentMonthVoucherSumV1 } from '../fn/enrollment-schedule/enrollment-schedule-controller-find-current-month-voucher-sum-v-1';
import { EnrollmentScheduleControllerFindCurrentMonthVoucherSumV1$Params } from '../fn/enrollment-schedule/enrollment-schedule-controller-find-current-month-voucher-sum-v-1';
import { enrollmentScheduleControllerFindLastScheduleV1 } from '../fn/enrollment-schedule/enrollment-schedule-controller-find-last-schedule-v-1';
import { EnrollmentScheduleControllerFindLastScheduleV1$Params } from '../fn/enrollment-schedule/enrollment-schedule-controller-find-last-schedule-v-1';
import { enrollmentScheduleControllerFindSupplementByIdV1 } from '../fn/enrollment-schedule/enrollment-schedule-controller-find-supplement-by-id-v-1';
import { EnrollmentScheduleControllerFindSupplementByIdV1$Params } from '../fn/enrollment-schedule/enrollment-schedule-controller-find-supplement-by-id-v-1';
import { enrollmentScheduleControllerFindV1 } from '../fn/enrollment-schedule/enrollment-schedule-controller-find-v-1';
import { EnrollmentScheduleControllerFindV1$Params } from '../fn/enrollment-schedule/enrollment-schedule-controller-find-v-1';
import { enrollmentScheduleControllerSearchCursorByTicketIdV1 } from '../fn/enrollment-schedule/enrollment-schedule-controller-search-cursor-by-ticket-id-v-1';
import { EnrollmentScheduleControllerSearchCursorByTicketIdV1$Params } from '../fn/enrollment-schedule/enrollment-schedule-controller-search-cursor-by-ticket-id-v-1';
import { enrollmentScheduleControllerSearchOffsetByTicketIdV1 } from '../fn/enrollment-schedule/enrollment-schedule-controller-search-offset-by-ticket-id-v-1';
import { EnrollmentScheduleControllerSearchOffsetByTicketIdV1$Params } from '../fn/enrollment-schedule/enrollment-schedule-controller-search-offset-by-ticket-id-v-1';
import { enrollmentScheduleControllerSearchTodayScheduleV1 } from '../fn/enrollment-schedule/enrollment-schedule-controller-search-today-schedule-v-1';
import { EnrollmentScheduleControllerSearchTodayScheduleV1$Params } from '../fn/enrollment-schedule/enrollment-schedule-controller-search-today-schedule-v-1';
import { enrollmentScheduleControllerUpdateDateV1 } from '../fn/enrollment-schedule/enrollment-schedule-controller-update-date-v-1';
import { EnrollmentScheduleControllerUpdateDateV1$Params } from '../fn/enrollment-schedule/enrollment-schedule-controller-update-date-v-1';
import { enrollmentScheduleControllerUpdateRepeatV1 } from '../fn/enrollment-schedule/enrollment-schedule-controller-update-repeat-v-1';
import { EnrollmentScheduleControllerUpdateRepeatV1$Params } from '../fn/enrollment-schedule/enrollment-schedule-controller-update-repeat-v-1';
import { enrollmentScheduleControllerUpdateSupplementV1 } from '../fn/enrollment-schedule/enrollment-schedule-controller-update-supplement-v-1';
import { EnrollmentScheduleControllerUpdateSupplementV1$Params } from '../fn/enrollment-schedule/enrollment-schedule-controller-update-supplement-v-1';
import { enrollmentScheduleControllerUpdateV1 } from '../fn/enrollment-schedule/enrollment-schedule-controller-update-v-1';
import { EnrollmentScheduleControllerUpdateV1$Params } from '../fn/enrollment-schedule/enrollment-schedule-controller-update-v-1';
import { EnrollmentScheduleCountDto } from '../models/enrollment-schedule-count-dto';
import { EnrollmentScheduleDto } from '../models/enrollment-schedule-dto';
import { enrollmentScheduleNoAuthControllerFindByIdsV1 } from '../fn/enrollment-schedule/enrollment-schedule-no-auth-controller-find-by-ids-v-1';
import { EnrollmentScheduleNoAuthControllerFindByIdsV1$Params } from '../fn/enrollment-schedule/enrollment-schedule-no-auth-controller-find-by-ids-v-1';
import { EnrollmentScheduleSumDto } from '../models/enrollment-schedule-sum-dto';
import { FindEnrollmentScheduleResponseDto } from '../models/find-enrollment-schedule-response-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';
import { SearchEnrollmentScheduleResponseDto } from '../models/search-enrollment-schedule-response-dto';

@Injectable({ providedIn: 'root' })
export class EnrollmentScheduleService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `enrollmentScheduleControllerFindV1()` */
  static readonly EnrollmentScheduleControllerFindV1Path = '/api/v1/enrollment-schedule';

  /**
   * 서비스 일정 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `enrollmentScheduleControllerFindV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  enrollmentScheduleControllerFindV1$Response(params?: EnrollmentScheduleControllerFindV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EnrollmentScheduleDto>>> {
    return enrollmentScheduleControllerFindV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 서비스 일정 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `enrollmentScheduleControllerFindV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  enrollmentScheduleControllerFindV1(params?: EnrollmentScheduleControllerFindV1$Params, context?: HttpContext): Observable<Array<EnrollmentScheduleDto>> {
    return this.enrollmentScheduleControllerFindV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<EnrollmentScheduleDto>>): Array<EnrollmentScheduleDto> => r.body)
    );
  }

  /** Path part for operation `enrollmentScheduleControllerCreateV1()` */
  static readonly EnrollmentScheduleControllerCreateV1Path = '/api/v1/enrollment-schedule';

  /**
   * 서비스 일정 등록.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `enrollmentScheduleControllerCreateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  enrollmentScheduleControllerCreateV1$Response(params: EnrollmentScheduleControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return enrollmentScheduleControllerCreateV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 서비스 일정 등록.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `enrollmentScheduleControllerCreateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  enrollmentScheduleControllerCreateV1(params: EnrollmentScheduleControllerCreateV1$Params, context?: HttpContext): Observable<boolean> {
    return this.enrollmentScheduleControllerCreateV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `enrollmentScheduleControllerSearchTodayScheduleV1()` */
  static readonly EnrollmentScheduleControllerSearchTodayScheduleV1Path = '/api/v1/enrollment-schedule/today-receipt';

  /**
   * 금일 수납 일정 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `enrollmentScheduleControllerSearchTodayScheduleV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  enrollmentScheduleControllerSearchTodayScheduleV1$Response(params: EnrollmentScheduleControllerSearchTodayScheduleV1$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return enrollmentScheduleControllerSearchTodayScheduleV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 금일 수납 일정 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `enrollmentScheduleControllerSearchTodayScheduleV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  enrollmentScheduleControllerSearchTodayScheduleV1(params: EnrollmentScheduleControllerSearchTodayScheduleV1$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.enrollmentScheduleControllerSearchTodayScheduleV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `enrollmentScheduleControllerFindCountV1()` */
  static readonly EnrollmentScheduleControllerFindCountV1Path = '/api/v1/enrollment-schedule/count';

  /**
   * 오늘/이번주 일정 갯소 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `enrollmentScheduleControllerFindCountV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  enrollmentScheduleControllerFindCountV1$Response(params: EnrollmentScheduleControllerFindCountV1$Params, context?: HttpContext): Observable<StrictHttpResponse<EnrollmentScheduleCountDto>> {
    return enrollmentScheduleControllerFindCountV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 오늘/이번주 일정 갯소 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `enrollmentScheduleControllerFindCountV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  enrollmentScheduleControllerFindCountV1(params: EnrollmentScheduleControllerFindCountV1$Params, context?: HttpContext): Observable<EnrollmentScheduleCountDto> {
    return this.enrollmentScheduleControllerFindCountV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<EnrollmentScheduleCountDto>): EnrollmentScheduleCountDto => r.body)
    );
  }

  /** Path part for operation `enrollmentScheduleControllerFindLastScheduleV1()` */
  static readonly EnrollmentScheduleControllerFindLastScheduleV1Path = '/api/v1/enrollment-schedule/last';

  /**
   * 마지막 서비스 일정 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `enrollmentScheduleControllerFindLastScheduleV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  enrollmentScheduleControllerFindLastScheduleV1$Response(params: EnrollmentScheduleControllerFindLastScheduleV1$Params, context?: HttpContext): Observable<StrictHttpResponse<EnrollmentScheduleDto>> {
    return enrollmentScheduleControllerFindLastScheduleV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 마지막 서비스 일정 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `enrollmentScheduleControllerFindLastScheduleV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  enrollmentScheduleControllerFindLastScheduleV1(params: EnrollmentScheduleControllerFindLastScheduleV1$Params, context?: HttpContext): Observable<EnrollmentScheduleDto> {
    return this.enrollmentScheduleControllerFindLastScheduleV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<EnrollmentScheduleDto>): EnrollmentScheduleDto => r.body)
    );
  }

  /** Path part for operation `enrollmentScheduleControllerFindByCurrentMonthTicketV1()` */
  static readonly EnrollmentScheduleControllerFindByCurrentMonthTicketV1Path = '/api/v1/enrollment-schedule/month';

  /**
   * 금월 회기 계산.
   *
   * 일정을(를) 월별로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `enrollmentScheduleControllerFindByCurrentMonthTicketV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  enrollmentScheduleControllerFindByCurrentMonthTicketV1$Response(params: EnrollmentScheduleControllerFindByCurrentMonthTicketV1$Params, context?: HttpContext): Observable<StrictHttpResponse<CurrentMonthCountEnrollmentScheduleDto>> {
    return enrollmentScheduleControllerFindByCurrentMonthTicketV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 금월 회기 계산.
   *
   * 일정을(를) 월별로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `enrollmentScheduleControllerFindByCurrentMonthTicketV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  enrollmentScheduleControllerFindByCurrentMonthTicketV1(params: EnrollmentScheduleControllerFindByCurrentMonthTicketV1$Params, context?: HttpContext): Observable<CurrentMonthCountEnrollmentScheduleDto> {
    return this.enrollmentScheduleControllerFindByCurrentMonthTicketV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<CurrentMonthCountEnrollmentScheduleDto>): CurrentMonthCountEnrollmentScheduleDto => r.body)
    );
  }

  /** Path part for operation `enrollmentScheduleControllerFindCurrentMonthVoucherSumV1()` */
  static readonly EnrollmentScheduleControllerFindCurrentMonthVoucherSumV1Path = '/api/v1/enrollment-schedule/month/sum';

  /**
   * 금월 회기 합계 계산.
   *
   * 금월 회기 합계를 계산합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `enrollmentScheduleControllerFindCurrentMonthVoucherSumV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  enrollmentScheduleControllerFindCurrentMonthVoucherSumV1$Response(params: EnrollmentScheduleControllerFindCurrentMonthVoucherSumV1$Params, context?: HttpContext): Observable<StrictHttpResponse<EnrollmentScheduleSumDto>> {
    return enrollmentScheduleControllerFindCurrentMonthVoucherSumV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 금월 회기 합계 계산.
   *
   * 금월 회기 합계를 계산합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `enrollmentScheduleControllerFindCurrentMonthVoucherSumV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  enrollmentScheduleControllerFindCurrentMonthVoucherSumV1(params: EnrollmentScheduleControllerFindCurrentMonthVoucherSumV1$Params, context?: HttpContext): Observable<EnrollmentScheduleSumDto> {
    return this.enrollmentScheduleControllerFindCurrentMonthVoucherSumV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<EnrollmentScheduleSumDto>): EnrollmentScheduleSumDto => r.body)
    );
  }

  /** Path part for operation `enrollmentScheduleControllerFindByTicketIdV1()` */
  static readonly EnrollmentScheduleControllerFindByTicketIdV1Path = '/api/v1/enrollment-schedule/ticket';

  /**
   * 선택된 서비스 일정 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `enrollmentScheduleControllerFindByTicketIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  enrollmentScheduleControllerFindByTicketIdV1$Response(params: EnrollmentScheduleControllerFindByTicketIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EnrollmentScheduleDto>>> {
    return enrollmentScheduleControllerFindByTicketIdV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 선택된 서비스 일정 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `enrollmentScheduleControllerFindByTicketIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  enrollmentScheduleControllerFindByTicketIdV1(params: EnrollmentScheduleControllerFindByTicketIdV1$Params, context?: HttpContext): Observable<Array<EnrollmentScheduleDto>> {
    return this.enrollmentScheduleControllerFindByTicketIdV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<EnrollmentScheduleDto>>): Array<EnrollmentScheduleDto> => r.body)
    );
  }

  /** Path part for operation `enrollmentScheduleControllerFindSupplementByIdV1()` */
  static readonly EnrollmentScheduleControllerFindSupplementByIdV1Path = '/api/v1/enrollment-schedule/supplement/{id}';

  /**
   * 서비스 보강 일정 상세 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `enrollmentScheduleControllerFindSupplementByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  enrollmentScheduleControllerFindSupplementByIdV1$Response(params: EnrollmentScheduleControllerFindSupplementByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<EnrollmentScheduleDto>> {
    return enrollmentScheduleControllerFindSupplementByIdV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 서비스 보강 일정 상세 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `enrollmentScheduleControllerFindSupplementByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  enrollmentScheduleControllerFindSupplementByIdV1(params: EnrollmentScheduleControllerFindSupplementByIdV1$Params, context?: HttpContext): Observable<EnrollmentScheduleDto> {
    return this.enrollmentScheduleControllerFindSupplementByIdV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<EnrollmentScheduleDto>): EnrollmentScheduleDto => r.body)
    );
  }

  /** Path part for operation `enrollmentScheduleControllerSearchOffsetByTicketIdV1()` */
  static readonly EnrollmentScheduleControllerSearchOffsetByTicketIdV1Path = '/api/v1/enrollment-schedule/ticket/offset';

  /**
   * 오프셋기반 서비스 일정 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `enrollmentScheduleControllerSearchOffsetByTicketIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  enrollmentScheduleControllerSearchOffsetByTicketIdV1$Response(params: EnrollmentScheduleControllerSearchOffsetByTicketIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<SearchEnrollmentScheduleResponseDto>> {
    return enrollmentScheduleControllerSearchOffsetByTicketIdV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 오프셋기반 서비스 일정 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `enrollmentScheduleControllerSearchOffsetByTicketIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  enrollmentScheduleControllerSearchOffsetByTicketIdV1(params: EnrollmentScheduleControllerSearchOffsetByTicketIdV1$Params, context?: HttpContext): Observable<SearchEnrollmentScheduleResponseDto> {
    return this.enrollmentScheduleControllerSearchOffsetByTicketIdV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<SearchEnrollmentScheduleResponseDto>): SearchEnrollmentScheduleResponseDto => r.body)
    );
  }

  /** Path part for operation `enrollmentScheduleControllerFindAllByTicketIdV1()` */
  static readonly EnrollmentScheduleControllerFindAllByTicketIdV1Path = '/api/v1/enrollment-schedule/ticket/all/{ticketId}';

  /**
   * 선택된 서비스 일정 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `enrollmentScheduleControllerFindAllByTicketIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  enrollmentScheduleControllerFindAllByTicketIdV1$Response(params: EnrollmentScheduleControllerFindAllByTicketIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<FindEnrollmentScheduleResponseDto>> {
    return enrollmentScheduleControllerFindAllByTicketIdV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 선택된 서비스 일정 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `enrollmentScheduleControllerFindAllByTicketIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  enrollmentScheduleControllerFindAllByTicketIdV1(params: EnrollmentScheduleControllerFindAllByTicketIdV1$Params, context?: HttpContext): Observable<FindEnrollmentScheduleResponseDto> {
    return this.enrollmentScheduleControllerFindAllByTicketIdV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<FindEnrollmentScheduleResponseDto>): FindEnrollmentScheduleResponseDto => r.body)
    );
  }

  /** Path part for operation `enrollmentScheduleControllerSearchCursorByTicketIdV1()` */
  static readonly EnrollmentScheduleControllerSearchCursorByTicketIdV1Path = '/api/v1/enrollment-schedule/ticket/cursor/{ticketId}';

  /**
   * 선택된 서비스 일정 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `enrollmentScheduleControllerSearchCursorByTicketIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  enrollmentScheduleControllerSearchCursorByTicketIdV1$Response(params: EnrollmentScheduleControllerSearchCursorByTicketIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorSearchEnrollmentScheduleResponseDto>> {
    return enrollmentScheduleControllerSearchCursorByTicketIdV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 선택된 서비스 일정 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `enrollmentScheduleControllerSearchCursorByTicketIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  enrollmentScheduleControllerSearchCursorByTicketIdV1(params: EnrollmentScheduleControllerSearchCursorByTicketIdV1$Params, context?: HttpContext): Observable<CursorSearchEnrollmentScheduleResponseDto> {
    return this.enrollmentScheduleControllerSearchCursorByTicketIdV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<CursorSearchEnrollmentScheduleResponseDto>): CursorSearchEnrollmentScheduleResponseDto => r.body)
    );
  }

  /** Path part for operation `enrollmentScheduleControllerFindByIdV1()` */
  static readonly EnrollmentScheduleControllerFindByIdV1Path = '/api/v1/enrollment-schedule/{id}';

  /**
   * 서비스 일정 상세 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `enrollmentScheduleControllerFindByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  enrollmentScheduleControllerFindByIdV1$Response(params: EnrollmentScheduleControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<EnrollmentScheduleDto>> {
    return enrollmentScheduleControllerFindByIdV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 서비스 일정 상세 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `enrollmentScheduleControllerFindByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  enrollmentScheduleControllerFindByIdV1(params: EnrollmentScheduleControllerFindByIdV1$Params, context?: HttpContext): Observable<EnrollmentScheduleDto> {
    return this.enrollmentScheduleControllerFindByIdV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<EnrollmentScheduleDto>): EnrollmentScheduleDto => r.body)
    );
  }

  /** Path part for operation `enrollmentScheduleControllerDeleteV1()` */
  static readonly EnrollmentScheduleControllerDeleteV1Path = '/api/v1/enrollment-schedule/{id}';

  /**
   * 서비스 일정 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `enrollmentScheduleControllerDeleteV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  enrollmentScheduleControllerDeleteV1$Response(params: EnrollmentScheduleControllerDeleteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return enrollmentScheduleControllerDeleteV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 서비스 일정 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `enrollmentScheduleControllerDeleteV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  enrollmentScheduleControllerDeleteV1(params: EnrollmentScheduleControllerDeleteV1$Params, context?: HttpContext): Observable<boolean> {
    return this.enrollmentScheduleControllerDeleteV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `enrollmentScheduleControllerUpdateV1()` */
  static readonly EnrollmentScheduleControllerUpdateV1Path = '/api/v1/enrollment-schedule/{id}';

  /**
   * 서비스 일정 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `enrollmentScheduleControllerUpdateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  enrollmentScheduleControllerUpdateV1$Response(params: EnrollmentScheduleControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return enrollmentScheduleControllerUpdateV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 서비스 일정 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `enrollmentScheduleControllerUpdateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  enrollmentScheduleControllerUpdateV1(params: EnrollmentScheduleControllerUpdateV1$Params, context?: HttpContext): Observable<boolean> {
    return this.enrollmentScheduleControllerUpdateV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `enrollmentScheduleControllerCreateSupplementV1()` */
  static readonly EnrollmentScheduleControllerCreateSupplementV1Path = '/api/v1/enrollment-schedule/supplement';

  /**
   * 서비스 보강 일정 등록.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `enrollmentScheduleControllerCreateSupplementV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  enrollmentScheduleControllerCreateSupplementV1$Response(params: EnrollmentScheduleControllerCreateSupplementV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return enrollmentScheduleControllerCreateSupplementV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 서비스 보강 일정 등록.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `enrollmentScheduleControllerCreateSupplementV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  enrollmentScheduleControllerCreateSupplementV1(params: EnrollmentScheduleControllerCreateSupplementV1$Params, context?: HttpContext): Observable<boolean> {
    return this.enrollmentScheduleControllerCreateSupplementV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `enrollmentScheduleControllerCancelScheduleV1()` */
  static readonly EnrollmentScheduleControllerCancelScheduleV1Path = '/api/v1/enrollment-schedule/cancel';

  /**
   * 서비스 일정 취소.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `enrollmentScheduleControllerCancelScheduleV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  enrollmentScheduleControllerCancelScheduleV1$Response(params: EnrollmentScheduleControllerCancelScheduleV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return enrollmentScheduleControllerCancelScheduleV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 서비스 일정 취소.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `enrollmentScheduleControllerCancelScheduleV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  enrollmentScheduleControllerCancelScheduleV1(params: EnrollmentScheduleControllerCancelScheduleV1$Params, context?: HttpContext): Observable<boolean> {
    return this.enrollmentScheduleControllerCancelScheduleV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `enrollmentScheduleControllerUpdateDateV1()` */
  static readonly EnrollmentScheduleControllerUpdateDateV1Path = '/api/v1/enrollment-schedule/date';

  /**
   * 서비스 일정 날짜 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `enrollmentScheduleControllerUpdateDateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  enrollmentScheduleControllerUpdateDateV1$Response(params: EnrollmentScheduleControllerUpdateDateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return enrollmentScheduleControllerUpdateDateV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 서비스 일정 날짜 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `enrollmentScheduleControllerUpdateDateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  enrollmentScheduleControllerUpdateDateV1(params: EnrollmentScheduleControllerUpdateDateV1$Params, context?: HttpContext): Observable<boolean> {
    return this.enrollmentScheduleControllerUpdateDateV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `enrollmentScheduleControllerCopyV1()` */
  static readonly EnrollmentScheduleControllerCopyV1Path = '/api/v1/enrollment-schedule/copy';

  /**
   * 서비스 일정 복사.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `enrollmentScheduleControllerCopyV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  enrollmentScheduleControllerCopyV1$Response(params: EnrollmentScheduleControllerCopyV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return enrollmentScheduleControllerCopyV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 서비스 일정 복사.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `enrollmentScheduleControllerCopyV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  enrollmentScheduleControllerCopyV1(params: EnrollmentScheduleControllerCopyV1$Params, context?: HttpContext): Observable<boolean> {
    return this.enrollmentScheduleControllerCopyV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `enrollmentScheduleControllerUpdateSupplementV1()` */
  static readonly EnrollmentScheduleControllerUpdateSupplementV1Path = '/api/v1/enrollment-schedule/{id}/supplement';

  /**
   * 서비스 보강 일정 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `enrollmentScheduleControllerUpdateSupplementV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  enrollmentScheduleControllerUpdateSupplementV1$Response(params: EnrollmentScheduleControllerUpdateSupplementV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return enrollmentScheduleControllerUpdateSupplementV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 서비스 보강 일정 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `enrollmentScheduleControllerUpdateSupplementV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  enrollmentScheduleControllerUpdateSupplementV1(params: EnrollmentScheduleControllerUpdateSupplementV1$Params, context?: HttpContext): Observable<boolean> {
    return this.enrollmentScheduleControllerUpdateSupplementV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `enrollmentScheduleControllerUpdateRepeatV1()` */
  static readonly EnrollmentScheduleControllerUpdateRepeatV1Path = '/api/v1/enrollment-schedule/{id}/repeat';

  /**
   * 서비스 반복 일정 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `enrollmentScheduleControllerUpdateRepeatV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  enrollmentScheduleControllerUpdateRepeatV1$Response(params: EnrollmentScheduleControllerUpdateRepeatV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return enrollmentScheduleControllerUpdateRepeatV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 서비스 반복 일정 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `enrollmentScheduleControllerUpdateRepeatV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  enrollmentScheduleControllerUpdateRepeatV1(params: EnrollmentScheduleControllerUpdateRepeatV1$Params, context?: HttpContext): Observable<boolean> {
    return this.enrollmentScheduleControllerUpdateRepeatV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `enrollmentScheduleControllerDeleteRepeatV1()` */
  static readonly EnrollmentScheduleControllerDeleteRepeatV1Path = '/api/v1/enrollment-schedule/repeat/{id}';

  /**
   * 서비스 반복 일정 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `enrollmentScheduleControllerDeleteRepeatV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  enrollmentScheduleControllerDeleteRepeatV1$Response(params: EnrollmentScheduleControllerDeleteRepeatV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return enrollmentScheduleControllerDeleteRepeatV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 서비스 반복 일정 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `enrollmentScheduleControllerDeleteRepeatV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  enrollmentScheduleControllerDeleteRepeatV1(params: EnrollmentScheduleControllerDeleteRepeatV1$Params, context?: HttpContext): Observable<boolean> {
    return this.enrollmentScheduleControllerDeleteRepeatV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `enrollmentScheduleNoAuthControllerFindByIdsV1()` */
  static readonly EnrollmentScheduleNoAuthControllerFindByIdsV1Path = '/api/v1/enrollment-schedule-no-auth/ids';

  /**
   * 서비스 일정 ID로 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `enrollmentScheduleNoAuthControllerFindByIdsV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  enrollmentScheduleNoAuthControllerFindByIdsV1$Response(params: EnrollmentScheduleNoAuthControllerFindByIdsV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EnrollmentScheduleDto>>> {
    return enrollmentScheduleNoAuthControllerFindByIdsV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 서비스 일정 ID로 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `enrollmentScheduleNoAuthControllerFindByIdsV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  enrollmentScheduleNoAuthControllerFindByIdsV1(params: EnrollmentScheduleNoAuthControllerFindByIdsV1$Params, context?: HttpContext): Observable<Array<EnrollmentScheduleDto>> {
    return this.enrollmentScheduleNoAuthControllerFindByIdsV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<EnrollmentScheduleDto>>): Array<EnrollmentScheduleDto> => r.body)
    );
  }

}
